import { c as _c } from "react/compiler-runtime";
import { css, cx } from '@repo/pandacss/css';
import type { JsxStyleProps } from '@repo/pandacss/types';
import type { ComponentPropsWithRef, ReactNode } from 'react';
import type { CommonProps } from '../types';
export type CustomizedSummaryDetailsProps = CommonProps & {
  variant: 'customizedSummary';
  CollapseDetailsComponent: ReactNode;
  collapseDetailsParentProps?: ComponentPropsWithRef<'span'> & JsxStyleProps;
  ExpandDetailsComponent: ReactNode;
  expandDetailsParentProps?: ComponentPropsWithRef<'span'> & JsxStyleProps;
};
const detailsBaseStyles = css.raw({
  position: 'relative',
  '& > summary > [data-summary="open"]': {
    display: 'flex'
  },
  '& > summary > [data-summary="close"]': {
    display: 'none'
  },
  _open: {
    '& > summary > [data-summary="open"]': {
      display: 'none'
    },
    '& > summary > [data-summary="close"]': {
      display: 'flex'
    }
  }
});
const summaryBaseStyles = css.raw({
  listStyleType: 'none',
  _marker: {
    display: 'none'
  },
  cursor: 'pointer'
});
export function CustomizedSummaryDetails(t0) {
  const $ = _c(34);
  const {
    children,
    CollapseDetailsComponent,
    collapseDetailsParentProps: t1,
    detailsProps: t2,
    ExpandDetailsComponent,
    expandDetailsParentProps: t3,
    summaryProps: t4
  } = t0;
  let restCollapseDetailsProps;
  let t10;
  let t11;
  let t12;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== ExpandDetailsComponent || $[1] !== t1 || $[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    const collapseDetailsParentProps = t1 === undefined ? {} : t1;
    const detailsProps = t2 === undefined ? {} : t2;
    const expandDetailsParentProps = t3 === undefined ? {} : t3;
    const summaryProps = t4 === undefined ? {} : t4;
    const {
      className: detailsClassName,
      css: detailsCss,
      ...restDetailsProps
    } = detailsProps;
    const {
      className: summaryClassName,
      css: summaryCss,
      ...restSummaryProps
    } = summaryProps;
    const {
      className: expandDetailsClassName,
      css: expandDetailsCss,
      ...restExpandDetailsProps
    } = expandDetailsParentProps;
    const {
      className: collapseDetailsClassName,
      css: collapseDetailsCss,
      ...t13
    } = collapseDetailsParentProps;
    restCollapseDetailsProps = t13;
    t11 = cx(css(detailsBaseStyles, detailsCss), detailsClassName);
    t12 = restDetailsProps;
    t7 = "detail-summary";
    t8 = cx(css(summaryBaseStyles, summaryCss), summaryClassName);
    t9 = restSummaryProps;
    const t14 = cx(css(expandDetailsCss), expandDetailsClassName);
    if ($[14] !== ExpandDetailsComponent || $[15] !== restExpandDetailsProps || $[16] !== t14) {
      t10 = <span data-summary="open" className={t14} {...restExpandDetailsProps}>{ExpandDetailsComponent}</span>;
      $[14] = ExpandDetailsComponent;
      $[15] = restExpandDetailsProps;
      $[16] = t14;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    t5 = "close";
    t6 = cx(css(collapseDetailsCss), collapseDetailsClassName);
    $[0] = ExpandDetailsComponent;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = restCollapseDetailsProps;
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    restCollapseDetailsProps = $[5];
    t10 = $[6];
    t11 = $[7];
    t12 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
    t9 = $[13];
  }
  let t13;
  if ($[18] !== CollapseDetailsComponent || $[19] !== restCollapseDetailsProps || $[20] !== t5 || $[21] !== t6) {
    t13 = <span data-summary={t5} className={t6} {...restCollapseDetailsProps}>{CollapseDetailsComponent}</span>;
    $[18] = CollapseDetailsComponent;
    $[19] = restCollapseDetailsProps;
    $[20] = t5;
    $[21] = t6;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t10 || $[24] !== t13 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t14 = <summary data-testid={t7} className={t8} {...t9}>{t10}{t13}</summary>;
    $[23] = t10;
    $[24] = t13;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== children || $[30] !== t11 || $[31] !== t12 || $[32] !== t14) {
    t15 = <details className={t11} {...t12}>{t14}{children}</details>;
    $[29] = children;
    $[30] = t11;
    $[31] = t12;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
}